// src/components/settings/sections/LoyaltyProgramSettings.js
import React, { useState } from 'react';
import Toggle from "../common/Toggle";


const LoyaltyProgramSettings = () => {
    const [pointsPerDollar, setPointsPerDollar] = useState('10');
    const [minRedeemPoints, setMinRedeemPoints] = useState('500');
    const [rewardExpirationEnabled, setRewardExpirationEnabled] = useState(true);
    const [expirationPeriod, setExpirationPeriod] = useState('12'); // in months
    const [enrollmentConfirmationEmail, setEnrollmentConfirmationEmail] = useState(true);
    const [balanceUpdateNotifications, setBalanceUpdateNotifications] = useState(false);

    const handleSave = (e) => {
        e.preventDefault();
        alert('Loyalty Program settings saved!');
        console.log('Saved Loyalty Program Settings:', {
            pointsPerDollar, minRedeemPoints, rewardExpirationEnabled, expirationPeriod,
            enrollmentConfirmationEmail, balanceUpdateNotifications
        });
    };

    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-semibold text-gray-800">Loyalty Program Settings</h2>
            <p className="text-gray-600">Configure global rules and preferences for your loyalty program.</p>

            <form onSubmit={handleSave} className="space-y-6 mt-6">
                {/* Point Earning Rule */}
                <div>
                    <label htmlFor="pointsPerDollar" className="block text-sm font-medium text-gray-700">Points Earned per R1 Spent</label>
                    <div className="mt-1 flex rounded-md shadow-sm">
                        <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
                            ZAR 1 =
                        </span>
                        <input
                            type="number"
                            id="pointsPerDollar"
                            value={pointsPerDollar}
                            onChange={(e) => setPointsPerDollar(e.target.value)}
                            className="flex-1 block w-full rounded-none rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                            min="1"
                        />
                        <span className="inline-flex items-center px-3 rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
              points
            </span>
                    </div>
                    <p className="mt-2 text-xs text-gray-500">Define how many points customers earn for every dollar spent.</p>
                </div>

                {/* Minimum Redemption Points */}
                <div>
                    <label htmlFor="minRedeemPoints" className="block text-sm font-medium text-gray-700">Minimum Points for Redemption</label>
                    <div className="mt-1 flex rounded-md shadow-sm">
                        <input
                            type="number"
                            id="minRedeemPoints"
                            value={minRedeemPoints}
                            onChange={(e) => setMinRedeemPoints(e.target.value)}
                            className="flex-1 block w-full rounded-l-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                            min="0"
                        />
                        <span className="inline-flex items-center px-3 rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
              points
            </span>
                    </div>
                    <p className="mt-2 text-xs text-gray-500">Customers must accumulate at least this many points to redeem rewards.</p>
                </div>

                {/* Reward Expiration */}
                <div className="flex items-center justify-between">
                    <div>
                        <label htmlFor="rewardExpirationEnabled" className="block text-sm font-medium text-gray-700">Reward Expiration</label>
                        <p className="mt-1 text-xs text-gray-500">Automatically expire unredeemed points or rewards.</p>
                    </div>
                    <Toggle
                        id="rewardExpirationEnabled"
                        checked={rewardExpirationEnabled}
                        onChange={setRewardExpirationEnabled}
                    />
                </div>

                {rewardExpirationEnabled && (
                    <div>
                        <label htmlFor="expirationPeriod" className="block text-sm font-medium text-gray-700">Expire after (months)</label>
                        <input
                            type="number"
                            id="expirationPeriod"
                            value={expirationPeriod}
                            onChange={(e) => setExpirationPeriod(e.target.value)}
                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                            min="1"
                        />
                    </div>
                )}

                {/* Notification Preferences */}
                <div className="border-t border-gray-200 pt-6">
                    <h3 className="text-lg font-medium text-gray-900 mb-4">Customer Notifications</h3>
                    <div className="space-y-4">
                        <div className="flex items-center justify-between">
                            <div>
                                <label htmlFor="enrollmentConfirmationEmail" className="block text-sm font-medium text-gray-700">Enrollment Confirmation Email</label>
                                <p className="mt-1 text-xs text-gray-500">Send an email when a new customer enrolls in your program.</p>
                            </div>
                            <Toggle
                                id="enrollmentConfirmationEmail"
                                checked={enrollmentConfirmationEmail}
                                onChange={setEnrollmentConfirmationEmail}
                            />
                        </div>

                        <div className="flex items-center justify-between">
                            <div>
                                <label htmlFor="balanceUpdateNotifications" className="block text-sm font-medium text-gray-700">Points Balance Update Notifications</label>
                                <p className="mt-1 text-xs text-gray-500">Notify customers when their points balance changes significantly.</p>
                            </div>
                            <Toggle
                                id="balanceUpdateNotifications"
                                checked={balanceUpdateNotifications}
                                onChange={setBalanceUpdateNotifications}
                            />
                        </div>
                    </div>
                </div>

                {/* Save Button */}
                <div className="pt-6 border-t border-gray-200 flex justify-end">
                    <button
                        type="submit"
                        className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        Save Changes
                    </button>
                </div>
            </form>
        </div>
    );
};

export default LoyaltyProgramSettings;